'use client';

export { RouteError as default } from '@/features/layout/components/route-error';
